import React, { Component, Fragment } from "react";
import NotificationSystem from "react-notification-system";
import { NOTIFICATION_SYSTEM_STYLE } from "../utils/constants";
import {
  MdDeleteForever,
  MdEdit,
  MdKeyboardArrowLeft,
  MdKeyboardArrowRight,
  MdArrowUpward,
  MdArrowDownward,
} from "react-icons/md";
import {
  Card,
  CardBody,
  CardHeader,
  Label,
  Input,
  Row,
  Col,
  Button,
  Table,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Form,
  FormGroup,
  UncontrolledCollapse,
  Tooltip,
} from "reactstrap";
import moment from "moment";
import { IoMdEye, IoMdEyeOff } from "react-icons/io";
import { FaArchive } from "react-icons/fa";
import { BsCircleFill } from "react-icons/bs";
import { HiOutlineClipboardCopy } from "react-icons/hi";
import TeamEdit from "./TeamEdit";
import * as Server from "../Server";
import PageSpinner from "../components/PageSpinner";
import Page from "../components/Page";
import { capitalizeFirstLetter } from "../GeneralFunctions";
import { GlobalContext } from "../components/Layout/MainLayout";
let selectedTeamId = "";

class Teams extends Component {
  constructor(props) {
    super(props);
    this.state = {
      teamEditPage: false,
      showLoader: false,
      page: 1,
      limit: 10,
      totalTeams: 0,
      pages: 0,
      pageNumbers: [],
      Teams: [],
      removeTeamConfirmationModal: false,
      teamEditKey: "",
      teamDetail: {},
      sortKey: false,
      filterCollapse: false,
      teamName: "",
      gender: "",
      isVisible: null,
      archiveTeamConfirmationModal: false,
      viewRegisterLinkModal: false,
      Camps: [],
      copyLinkTooltip: false,
      selectedIndex: 0,
      eyeTooltip: false,
      eyeOffTooltip: false,
      selectedTeamIndex: null,
    };
  }

  componentDidMount() {
    this.setState({ limit: this.context.limit }, () => this.getTeams());
  }

  getTeams = async (event) => {
    if (event) event.preventDefault();
    try {
      this.setState({ showLoader: true });
      let page = this.state.page;
      let pageLimit = this.state.limit;
      let response = await Server.request({
        url: "rushsoccer/teamlist",
        method: "POST",
        data: {
          page,
          pageLimit,
          gender: this.state.gender,
          teamName: this.state.teamName,
          isVisible: this.state.isVisible,
        },
      });
      if (response) {
        this.setState({
          showLoader: false,
          Teams: response.teams,
          totalTeams: response.totalTeams,
          pages: response.pages,
        });
        let pageNumbers = [];
        for (let page = 1; page <= response.pages; page++) {
          pageNumbers.push(page);
        }
        this.setState({ pageNumbers: pageNumbers });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  renderTeamEditPage(team, key) {
    if (key === "Create-Team") {
      this.setState({ teamEditPage: true, teamEditKey: key });
    } else {
      this.setState({ teamEditPage: true, teamEditKey: key, teamDetail: team });
    }
  }

  renderTeamPlayerPage(team) {
    this.props.history.push({
      pathname: "/teamplayers",
      state: { team: team },
    });
  }

  closeTeamEditPage() {
    this.setState({
      teamEditPage: false,
    });
    this.getTeams();
  }

  toggleRemoveTeamConfirmationModal = (id) => {
    if (!selectedTeamId && id) {
      selectedTeamId = id;
    }
    this.setState({
      removeTeamConfirmationModal: !this.state.removeTeamConfirmationModal,
    });
  };

  toggleArchiveTeamConfirmationModal = (id) => {
    if (!selectedTeamId && id) {
      selectedTeamId = id;
    }
    this.setState({
      archiveTeamConfirmationModal: !this.state.archiveTeamConfirmationModal,
    });
  };

  toggleRegisterLinkViewModal = (team) => {
    if (team) {
      this.setState({
        teamDetail: team,
        Camps: team.camps,
        viewRegisterLinkModal: !this.state.viewRegisterLinkModal,
      });
    } else {
      this.setState({
        viewRegisterLinkModal: !this.state.viewRegisterLinkModal,
      });
    }
  };

  removeTeam = async () => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushsoccer/team/delete",
        method: "POST",
        data: { teamId: selectedTeamId },
      });
      if (response) {
        this.setState({ showLoader: false });
        selectedTeamId = null;
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.getTeams();
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  archiveTeam = async () => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushsoccer/team/archive",
        method: "POST",
        data: { teamId: selectedTeamId },
      });
      if (response) {
        this.setState({ showLoader: false });
        selectedTeamId = null;
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.getTeams();
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  hideUnhideTeam = async (obj) => {
    try {
      let response = await Server.request({
        url: "rushsoccer/team/hideUnhide",
        method: "POST",
        data: obj,
      });
      if (response) {
        this.setState({ showLoader: false });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.getTeams();
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  refreshPagination = (page, limit) => {
    this.setState({ page: parseInt(page, 10), limit: limit }, () => {
      this.getTeams();
    });
  };

  SortByColumn = (e, key) => {
    e.preventDefault();
    let teams = [];
    if (this.state.sortKey === false) {
      teams = this.state.Teams.sort((a, b) => {
        if (a[key] < b[key]) return -1;
        if (a[key] > b[key]) return 1;
        return 0;
      });
      this.setState({ sortKey: true });
    } else {
      teams = this.state.Teams.sort((a, b) => {
        if (a[key] > b[key]) return -1;
        if (a[key] < b[key]) return 1;
        return 0;
      });
      this.setState({ sortKey: false });
    }
    this.setState({ Teams: teams });
  };

  render() {
    return (
      <Fragment>
        {this.state.teamEditPage ? (
          <TeamEdit
            team={this.state.teamDetail || {}}
            teamEditKey={this.state.teamEditKey}
            closeTeamEditPage={() => this.closeTeamEditPage()}
          ></TeamEdit>
        ) : (
          <div>
            <Page title={"Team"} breadcrumbs={[{ name: "Team", active: true }]}>
              <PageSpinner showLoader={this.state.showLoader} />
              <Row>
                <Col>
                  <Card>
                    <CardHeader>
                      <Row>
                        <Col xl={4} lg={12} md={12}>
                          <div className="d-flex">
                            <div sm={4} className="mt-2 pr-2">
                              <Label>Shown</Label>
                            </div>
                            <div sm={4}>
                              <Input
                                type="select"
                                name="pageLimit"
                                value={this.state.limit}
                                onChange={(event) => {
                                  this.refreshPagination(1, event.target.value);
                                  this.context.updateState({
                                    limit: event.target.value,
                                  });
                                }}
                              >
                                <option value={10}>10</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                              </Input>
                            </div>
                            <div sm={4} className="mt-2 pl-2">
                              <Label>entries</Label>
                            </div>
                          </div>
                        </Col>
                        <Col xl={4} lg={12} md={12}>
                          <div className="d-flex justify-content-center">
                            <div className="mt-2 pr-2">
                              <Label>
                                Showing{" "}
                                {!this.state.totalTeams
                                  ? 0
                                  : this.state.page * this.state.limit -
                                    (this.state.limit - 1) +
                                    " "}
                                to{" "}
                                {this.state.page * this.state.limit >
                                this.state.totalTeams
                                  ? this.state.totalTeams
                                  : this.state.page * this.state.limit}{" "}
                                of {this.state.totalTeams}
                              </Label>
                            </div>
                          </div>
                        </Col>
                        <Col xl={4} lg={12} md={12}>
                          <div className="d-flex justify-content-end">
                            <div sm={4} className="pr-2">
                              <Button
                                className="rounded-circle"
                                disabled={this.state.page <= 1}
                                onClick={(event) =>
                                  this.refreshPagination(
                                    this.state.page - 1,
                                    this.state.limit
                                  )
                                }
                              >
                                <MdKeyboardArrowLeft size="20px"></MdKeyboardArrowLeft>
                              </Button>
                            </div>
                            <div sm={4}>
                              <Input
                                type="select"
                                value={this.state.page}
                                name="filter"
                                onChange={(event) => {
                                  this.refreshPagination(
                                    event.target.value,
                                    this.state.limit
                                  );
                                }}
                              >
                                {this.state.pageNumbers.length !== 0 ? (
                                  this.state.pageNumbers.map(
                                    (pageNumber, index) => (
                                      <option value={pageNumber} key={index}>
                                        {pageNumber}
                                      </option>
                                    )
                                  )
                                ) : (
                                  <option value={0}>0</option>
                                )}
                              </Input>
                            </div>
                            <div sm={4} className="pl-2">
                              <Button
                                className="rounded-circle"
                                disabled={this.state.page >= this.state.pages}
                                onClick={(event) =>
                                  this.refreshPagination(
                                    this.state.page + 1,
                                    this.state.limit
                                  )
                                }
                              >
                                <MdKeyboardArrowRight size="20px"></MdKeyboardArrowRight>
                              </Button>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </CardHeader>
                    <CardBody>
                      <Row>
                        <Col xl={12} lg={12} md={12}>
                          <div className="d-flex justify-content-end">
                            <Button
                              id="toggler1"
                              className="float-right mr-1 mb-2"
                              onClick={() => {
                                this.setState({
                                  filterCollapse: !this.state.filterCollapse,
                                });
                              }}
                            >
                              Filters
                            </Button>
                            <Button
                              className="float-right mb-2"
                              onClick={(event) =>
                                this.renderTeamEditPage({}, "Create-Team")
                              }
                            >
                              Create New Team
                            </Button>
                          </div>
                        </Col>
                      </Row>
                      <UncontrolledCollapse
                        toggler="#toggler1"
                        isOpen={this.state.filterCollapse}
                      >
                        <Card>
                          <CardBody>
                            <Form
                              className="form"
                              onSubmit={(event) => this.getTeams(event)}
                            >
                              <Row>
                                <Col
                                  xl={6}
                                  lg={12}
                                  md={12}
                                  style={{ paddingRight: "0px" }}
                                >
                                  <FormGroup>
                                    <Label for="name">Search By Team</Label>
                                    <Input
                                      icon="search"
                                      value={this.state.teamName}
                                      placeholder="Search by Team"
                                      onChange={(event) =>
                                        this.setState({
                                          teamName: event.target.value,
                                        })
                                      }
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                              <Row>
                                <Col
                                  xl={6}
                                  lg={12}
                                  md={12}
                                  style={{ paddingRight: "0px" }}
                                >
                                  <FormGroup>
                                    <Label>Gender</Label>
                                    <FormGroup check>
                                      <span className="mr-5">
                                        <Input
                                          type="radio"
                                          name="boys"
                                          id="boys"
                                          value="boys"
                                          onClick={(event) =>
                                            this.setState({
                                              gender: event.target.value,
                                            })
                                          }
                                          checked={
                                            this.state.gender === "boys" && true
                                          }
                                        />
                                        <Label check for="boys">
                                          Boys
                                        </Label>
                                      </span>
                                      <Input
                                        type="radio"
                                        name="girls"
                                        id="girls"
                                        value="girls"
                                        onClick={(event) =>
                                          this.setState({
                                            gender: event.target.value,
                                          })
                                        }
                                        checked={
                                          this.state.gender === "girls" && true
                                        }
                                      />
                                      <Label check for="girls">
                                        Girls
                                      </Label>
                                    </FormGroup>
                                  </FormGroup>
                                </Col>
                              </Row>
                              <Row>
                                <Col
                                  xl={6}
                                  lg={12}
                                  md={12}
                                  style={{ paddingRight: "0px" }}
                                >
                                  <FormGroup>
                                    <Label>Status</Label>
                                    <FormGroup check>
                                      <span className="mr-5">
                                        <Input
                                          id="enable"
                                          type="radio"
                                          name="enable"
                                          value="true"
                                          onClick={(event) =>
                                            this.setState({ isVisible: true })
                                          }
                                          checked={this.state.isVisible}
                                        />
                                        <Label for="enable">Enable</Label>
                                      </span>
                                      <Input
                                        type="radio"
                                        name="disable"
                                        id="disable"
                                        value="false"
                                        onClick={(event) =>
                                          this.setState({ isVisible: false })
                                        }
                                        checked={
                                          this.state.isVisible !== null &&
                                          !this.state.isVisible &&
                                          true
                                        }
                                      />
                                      <Label for="disable">Disable</Label>
                                    </FormGroup>
                                  </FormGroup>
                                </Col>
                              </Row>
                              <Row>
                                <Col xl={6} lg={12} md={12}>
                                  <FormGroup>
                                    <Button
                                      className="mr-3"
                                      color="primary"
                                      type="submit"
                                    >
                                      Filter
                                    </Button>
                                    <Button
                                      onClick={() =>
                                        this.setState({
                                          gender: "",
                                          teamName: "",
                                          isVisible: null,
                                        })
                                      }
                                    >
                                      Reset Filter
                                    </Button>
                                  </FormGroup>
                                </Col>
                              </Row>
                            </Form>
                          </CardBody>
                        </Card>
                      </UncontrolledCollapse>
                      <Table striped hover responsive>
                        <thead>
                          <tr>
                            <th>
                              <div className="d-flex">
                                <Label>Team Name</Label>
                                <Label
                                  className="float-left"
                                  onClick={(e) =>
                                    this.SortByColumn(e, "name", 0)
                                  }
                                  style={{
                                    cursor: "pointer",
                                  }}
                                >
                                  {this.state.sortKey === true ? (
                                    <MdArrowUpward size="20px" />
                                  ) : (
                                    <MdArrowDownward size="20px" />
                                  )}
                                </Label>
                              </div>
                            </th>
                            <th>
                              <Label>Staff Members</Label>
                            </th>
                            <th>
                              <Label>Gender</Label>
                            </th>
                            <th>
                              <Label>Start Date</Label>
                            </th>
                            <th>
                              <Label>End Date</Label>
                            </th>
                            <th>
                              <Label>Status</Label>
                            </th>
                            <th>
                              <Label>Register</Label>
                            </th>
                            <th>
                              <Label>Action</Label>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.Teams && this.state.Teams.length > 0 ? (
                            this.state.Teams.map((team, index) => (
                              <tr key={index}>
                                <td>
                                  {capitalizeFirstLetter(team.name || "-")}
                                </td>
                                <td>
                                  {team.staffMembers.length > 0
                                    ? team.staffMembers.map((staff, index) => (
                                        <div className="d-flex" key={index}>
                                          <Label>
                                            {staff.data.firstName +
                                              " " +
                                              staff.data.lastName}{" "}
                                          </Label>
                                          {team.staffMembers.length !==
                                            index + 1 && ","}
                                        </div>
                                      ))
                                    : "-"}
                                </td>
                                <td>
                                  {team.gender
                                    ? capitalizeFirstLetter(team.gender)
                                    : "-"}
                                </td>
                                <td>
                                  {team.startDate
                                    ? moment(team.startDate).format("MM-YYYY")
                                    : "-"}
                                </td>
                                <td>
                                  {team.endDate
                                    ? moment(team.endDate).format("MM-YYYY")
                                    : "-"}
                                </td>
                                <td>
                                  {team.isVisible === true ? (
                                    <BsCircleFill color="#0cf10c"></BsCircleFill>
                                  ) : (
                                    <BsCircleFill></BsCircleFill>
                                  )}
                                </td>
                                <td>
                                  <Label
                                    className="text-primary "
                                    style={{
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      this.toggleRegisterLinkViewModal(team)
                                    }
                                  >
                                    Register
                                  </Label>
                                </td>
                                <td className="d-flex">
                                  <Button
                                    onClick={() =>
                                      this.renderTeamPlayerPage(team)
                                    }
                                  >
                                    View players
                                  </Button>
                                  {team.showTeam ? (
                                    <Button
                                      style={{ marginLeft: "10px" }}
                                      id={`eyeTooltip${index}`}
                                      onClick={(event) =>
                                        this.hideUnhideTeam({
                                          teamId: team._id,
                                          showTeam: false,
                                        })
                                      }
                                      onMouseOver={() =>
                                        this.setState({
                                          selectedTeamIndex: index,
                                          eyeTooltip: true,
                                        })
                                      }
                                      onMouseOut={() =>
                                        this.setState({
                                          selectedTeamIndex: null,
                                          eyeTooltip: false,
                                        })
                                      }
                                    >
                                      <IoMdEye size="20px"></IoMdEye>
                                      <Tooltip
                                        placement={"bottom"}
                                        isOpen={
                                          this.state.eyeTooltip &&
                                          this.state.selectedTeamIndex === index
                                        }
                                        target={`eyeTooltip${index}`}
                                        toggle={() => {}}
                                      >
                                        Hide Team
                                      </Tooltip>
                                    </Button>
                                  ) : (
                                    <Button
                                      style={{ marginLeft: "10px" }}
                                      id={`eyeOffTooltip${index}`}
                                      onClick={(event) =>
                                        this.hideUnhideTeam({
                                          teamId: team._id,
                                          showTeam: true,
                                        })
                                      }
                                      onMouseOver={() =>
                                        this.setState({
                                          selectedTeamIndex: index,
                                          eyeOffTooltip: true,
                                        })
                                      }
                                      onMouseOut={() =>
                                        this.setState({
                                          selectedTeamIndex: null,
                                          eyeOffTooltip: false,
                                        })
                                      }
                                    >
                                      <IoMdEyeOff size="20px"></IoMdEyeOff>
                                      <Tooltip
                                        placement={"bottom"}
                                        isOpen={
                                          this.state.eyeOffTooltip &&
                                          this.state.selectedTeamIndex === index
                                        }
                                        target={`eyeOffTooltip${index}`}
                                        toggle={() => {}}
                                      >
                                        Unhide Team
                                      </Tooltip>
                                    </Button>
                                  )}
                                  <Button
                                    style={{ marginLeft: "10px" }}
                                    onClick={(event) => {
                                      this.renderTeamEditPage(
                                        team,
                                        "Update-Team"
                                      );
                                    }}
                                  >
                                    <MdEdit size="20px"></MdEdit>
                                  </Button>
                                  <Button
                                    style={{ marginLeft: "10px" }}
                                    onClick={(event) => {
                                      this.toggleRemoveTeamConfirmationModal(
                                        team._id
                                      );
                                    }}
                                  >
                                    <MdDeleteForever size="20px"></MdDeleteForever>
                                  </Button>
                                  <Button
                                    style={{ marginLeft: "10px" }}
                                    onClick={(event) => {
                                      this.toggleArchiveTeamConfirmationModal(
                                        team._id
                                      );
                                    }}
                                  >
                                    <FaArchive size="20px"></FaArchive>
                                  </Button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="8" className="text-center">
                                No teams found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </CardBody>
                    {this.state.removeTeamConfirmationModal ? (
                      <Modal
                        isOpen={this.state.removeTeamConfirmationModal}
                        toggle={(event) =>
                          this.toggleRemoveTeamConfirmationModal()
                        }
                        className="modal-md"
                      >
                        <ModalHeader
                          toggle={(event) =>
                            this.toggleRemoveTeamConfirmationModal()
                          }
                        >
                          Delete Team
                        </ModalHeader>
                        <ModalBody>
                          Are you sure you want to delete this team ?
                        </ModalBody>
                        <ModalFooter>
                          <Button
                            color="secondary"
                            onClick={(event) =>
                              this.toggleRemoveTeamConfirmationModal()
                            }
                          >
                            Cancel
                          </Button>
                          <Button
                            color="primary"
                            onClick={(event) => {
                              this.removeTeam();
                              this.toggleRemoveTeamConfirmationModal();
                            }}
                          >
                            Delete
                          </Button>
                        </ModalFooter>
                      </Modal>
                    ) : null}
                    {this.state.archiveTeamConfirmationModal ? (
                      <Modal
                        isOpen={this.state.archiveTeamConfirmationModal}
                        toggle={(event) =>
                          this.toggleArchiveTeamConfirmationModal()
                        }
                        className="modal-md"
                      >
                        <ModalHeader
                          toggle={(event) =>
                            this.toggleArchiveTeamConfirmationModal()
                          }
                        >
                          Archive Team
                        </ModalHeader>
                        <ModalBody>
                          Are you sure you want to archive this team ?
                        </ModalBody>
                        <ModalFooter>
                          <Button
                            color="secondary"
                            onClick={(event) =>
                              this.toggleArchiveTeamConfirmationModal()
                            }
                          >
                            Cancel
                          </Button>
                          <Button
                            color="primary"
                            onClick={(event) => {
                              this.archiveTeam();
                              this.toggleArchiveTeamConfirmationModal();
                            }}
                          >
                            Archive
                          </Button>
                        </ModalFooter>
                      </Modal>
                    ) : null}
                    {this.state.viewRegisterLinkModal ? (
                      <Modal
                        isOpen={this.state.viewRegisterLinkModal}
                        toggle={(event) => this.toggleRegisterLinkViewModal()}
                        className="modal-md"
                      >
                        <ModalHeader
                          toggle={(event) => this.toggleRegisterLinkViewModal()}
                        >
                          Register Links
                        </ModalHeader>
                        <ModalBody>
                          <Table striped hover responsive>
                            <thead>
                              <tr>
                                <th className="textAlignCenter">Event Name</th>
                                <th className="textAlignCenter">
                                  Register Link
                                </th>
                                <th className="textAlignCenter">Copy Link</th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.Camps.length ? (
                                this.state.Camps.map((camp, index) => (
                                  <tr key={index}>
                                    <td className="textAlignCenter">
                                      {camp.name}
                                    </td>
                                    <td className="textAlignCenter">
                                      <a
                                        target="_blank"
                                        href={`${window.location.origin}/web/event/register?teamId=${this.state.teamDetail._id}&eventId=${camp._id}`}
                                      >
                                        Register
                                      </a>
                                    </td>
                                    <td className="textAlignCenter">
                                      <HiOutlineClipboardCopy
                                        id={`copyLinkTooltip${index}`}
                                        size="20px"
                                        style={{
                                          cursor: "pointer",
                                          outline: "unset",
                                        }}
                                        onClick={() => {
                                          this.setState({
                                            copyLinkTooltip: true,
                                            selectedIndex: index,
                                          });
                                          navigator.clipboard.writeText(
                                            `${window.location.origin}/web/event/register?teamId=${this.state.teamDetail._id}&eventId=${camp._id}`
                                          );
                                        }}
                                        onMouseOut={() =>
                                          this.setState({
                                            copyLinkTooltip: false,
                                          })
                                        }
                                      ></HiOutlineClipboardCopy>
                                      <Tooltip
                                        placement="top"
                                        isOpen={
                                          this.state.copyLinkTooltip &&
                                          this.state.selectedIndex === index
                                        }
                                        target={`copyLinkTooltip${index}`}
                                        toggle={() => {}}
                                      >
                                        Copied
                                      </Tooltip>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="3" className="text-center">
                                    No events found
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                        </ModalBody>
                      </Modal>
                    ) : null}
                  </Card>
                </Col>
              </Row>
              <NotificationSystem
                dismissible={false}
                ref={(notificationSystem) =>
                  (this.notificationSystem = notificationSystem)
                }
                style={NOTIFICATION_SYSTEM_STYLE}
              />
            </Page>
          </div>
        )}
      </Fragment>
    );
  }
}
Teams.contextType = GlobalContext;
export default Teams;
